export enum AlarmLevel {
    Caution,
    Warning,
    Alarm,

    None,
}

export const AlarmLevelKey = {
    [AlarmLevel.Caution] : 'channel.settings.alarm.caution-level',
    [AlarmLevel.Warning] : 'channel.settings.alarm.warning-level',
    [AlarmLevel.Alarm]: 'channel.settings.alarm.alarm-level',
    
    [AlarmLevel.None]: 'channel.settings.alarm.none-level'
};

export enum AlarmStatus {
    LOW = 'LOW',
    LOWLOW = 'LOW-LOW',
    HIGHHIGH = 'HIGH-HIGH',
    HIGH = 'HIGH',
    FAIL = 'FAIL',
    ABNORMAL = 'ABNORMAL',
    FEEDBACK = 'FEEDBACK',
    UNDEFINED = '',
}

export const DefaultAlarmLevel = AlarmLevel.Alarm;
